import { downloadSpeed, fixedBroadbandMsg, maxMbpsMsg, t, uploadSpeedMsg } from '../../../common/i18n/index.js';
import {
  getCharacteristicValueWithAddonPriority,
  getSpecValueWithAddonPriority,
} from '../../../common/utils/productOfferingsUtils.js';
import { getDefaultCardContentData } from './ProductOfferingCardContentUtils.js';
import type { ProductCardContentProps } from './types.js';

export const getFixedBroadbandCardContent = ({ productOffering }: ProductCardContentProps) => {
  const defaultData = getDefaultCardContentData(productOffering);

  const usageDescription = getCharacteristicValueWithAddonPriority(productOffering, 'usage_description');
  const audience = getCharacteristicValueWithAddonPriority(productOffering, 'audience');
  const usageDescription2 = getCharacteristicValueWithAddonPriority(productOffering, 'usage_description_2');
  const downloadSpeedValue = getSpecValueWithAddonPriority(productOffering, 'download_speed');
  const uploadSpeedValue = getSpecValueWithAddonPriority(productOffering, 'upload_speed');

  const marketingInfoItems = [
    ...(usageDescription ? [{ key: 'usage-description', icon: 'check', text: usageDescription }] : []),
    ...(audience ? [{ key: 'audience', icon: 'check', text: audience }] : []),
    ...(usageDescription2 ? [{ key: 'usage-description-2', icon: 'check', text: usageDescription2 }] : []),
    ...(downloadSpeedValue
      ? [
          {
            key: 'download-speed',
            icon: 'check',
            text: `${t.R4O4(downloadSpeed)} ${t.IJNT(maxMbpsMsg, downloadSpeedValue)}`,
          },
        ]
      : []),
    ...(uploadSpeedValue
      ? [
          {
            key: 'upload-speed',
            icon: 'check',
            text: `${t.CQQ7(uploadSpeedMsg)} ${t.IJNT(maxMbpsMsg, uploadSpeedValue)}`,
          },
        ]
      : []),
  ];

  const infoItems = marketingInfoItems.length > 0 ? marketingInfoItems : defaultData.infoItems;

  return {
    subHeader: t.QXQ7(fixedBroadbandMsg),
    badges: defaultData.badges,
    infoItems,
  };
};
